// Google Ads Tracking Utility
// Tag ID: AW-18018644214

// Track page views (automatic with gtag config, but can be called manually)
export const trackPageView = (pagePath, pageTitle) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'page_view', {
      page_path: pagePath,
      page_title: pageTitle
    });
  }
};

// Track Begin Checkout conversion (provided by Google Ads)
export const trackBeginCheckout = (value = 0, currency = 'AUD') => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'conversion', {
      'send_to': 'AW-18018644214/ynSFCIntoIkcEPbh-o9D',
      'value': value,
      'currency': currency
    });
  }
};

// Track Purchase/Booking completion
export const trackPurchase = (value = 440, currency = 'AUD', transactionId = '') => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'purchase', {
      'send_to': 'AW-18018644214',
      'value': value,
      'currency': currency,
      'transaction_id': transactionId
    });
  }
};

// Track form submissions (registration, enquiry)
export const trackFormSubmission = (formName) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'form_submission', {
      'event_category': 'engagement',
      'event_label': formName
    });
  }
};

// Track button clicks (CTA buttons)
export const trackButtonClick = (buttonName, buttonLocation) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'click', {
      'event_category': 'engagement',
      'event_label': buttonName,
      'button_location': buttonLocation
    });
  }
};

// Track program view
export const trackProgramView = (programName) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'view_item', {
      'event_category': 'programs',
      'event_label': programName
    });
  }
};

// Track enrollment start
export const trackEnrollmentStart = (programName, intakeId) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'begin_checkout', {
      'event_category': 'enrollment',
      'event_label': programName,
      'intake_id': intakeId
    });
    // Also fire the Google Ads conversion
    trackBeginCheckout(440, 'AUD');
  }
};

// Track user registration
export const trackRegistration = () => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'sign_up', {
      'event_category': 'user',
      'method': 'email'
    });
  }
};

// Track user login
export const trackLogin = () => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'login', {
      'event_category': 'user',
      'method': 'email'
    });
  }
};
